<div class="container">
  <div class="row justify-content-start align">
    <div class="fm-titlee">Assigned Sites</div>
    <div class="add-site col-12 assigned">
      @if (sites.length <= 0) {
        <div class="add-site noSite col-xs-12">
          <p class="not-found">No Sites found</p>
        </div>
      }
      @if (sites.length > 0) {
        <div cols="6" rowHeight="2:1" class="grid-layout-custom">
          @for (item of sites; track item; let i = $index) {
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 permissions-indvi-col">
              <div class="row">
                <div class="slideOne col-lg-3">
                  <mat-checkbox class="example-margin text-capitalize" type="checkbox" [disabled]="isEditable" checked
                    id="{{ item }}" (change)="assignSiteChange($event)" name="{{ item }}" disableRipple>{{ item
                  }}</mat-checkbox>
                </div>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>

  @if (
    authDetails.userDetails.role == 'superadmin' ||
    authDetails.userDetails.role == 'Vendoradmin'
    ) {
    <div class="row justify-content-start">
      <div class="fm-titlee">Available Sites</div>
      <div class="add-site col-12 available">
        @if (unselectedSites.length <= 0) {
          <div class="add-site noSite col-xs-12">
            <p class="not-found">No Sites found</p>
          </div>
        }
        @if (unselectedSites.length > 0) {
          <div cols="6" rowHeight="2:1" class="grid-layout-custom">
            @for (item of unselectedSites; track item; let i = $index) {
              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 permissions-indvi-col">
                <div class="row">
                  <div class="slideOne col-lg-3">
                    <mat-checkbox class="example-margin text-capitalize" type="checkbox" [disabled]="isEditable"
                      id="{{ item }}" (change)="availableSiteChange($event)" name="{{ item }}" disableRipple>{{ item
                    }}</mat-checkbox>
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>